import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import ItemsCarousel from "react-items-carousel";
import "../css/ThemeComponent.css";

const ThemeComponent = () => {
  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const chevronWidth = 40;
  return (
    <div className="container mt-3">
      <h5>Theme</h5>
      <ItemsCarousel
        requestToChangeActive={setActiveItemIndex}
        activeItemIndex={activeItemIndex}
        numberOfCards={5}
        gutter={20}
        leftChevron={<button>{"<"}</button>}
        rightChevron={<button>{">"}</button>}
        outsideChevron
        chevronWidth={chevronWidth}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
            background: "#EEE",
            backgroundImage: `url(https://images.pexels.com/photos/1078983/pexels-photo-1078983.jpeg?cs=srgb&dl=pexels-oliver-sj%C3%B6str%C3%B6m-1078983.jpg&fm=jpg)`,
            backgroundSize: "100%",
          }}
        >
          {/* First Card */}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
            background: "#EEE",
            backgroundSize: "100%",
            backgroundImage: `url(https://images.pexels.com/photos/1005417/pexels-photo-1005417.jpeg?cs=srgb&dl=pexels-oliver-sj%C3%B6str%C3%B6m-1005417.jpg&fm=jpg)`,
          }}
        >
          {/* First Card */}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
            background: "#EEE",
            backgroundSize: "100%",
            backgroundImage: `url(https://images.pexels.com/photos/315998/pexels-photo-315998.jpeg?cs=srgb&dl=pexels-pixabay-315998.jpg&fm=jpg)`,
          }}
        >
          {/* First Card */}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
            background: "#EEE",
            backgroundSize: "100%",
            backgroundImage: `url(https://images.pexels.com/photos/1433052/pexels-photo-1433052.jpeg?cs=srgb&dl=pexels-oliver-sj%C3%B6str%C3%B6m-1433052.jpg&fm=jpg)`,
          }}
        >
          {/* First Card */}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
            background: "#EEE",
            backgroundSize: "100%",
            backgroundImage: `url(https://images.pexels.com/photos/1078983/pexels-photo-1078983.jpeg?cs=srgb&dl=pexels-oliver-sj%C3%B6str%C3%B6m-1078983.jpg&fm=jpg)`,
          }}
        >
          {/* First Card */}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
            background: "#EEE",
            backgroundSize: "100%",
            backgroundImage: `url(https://images.pexels.com/photos/1078983/pexels-photo-1078983.jpeg?cs=srgb&dl=pexels-oliver-sj%C3%B6str%C3%B6m-1078983.jpg&fm=jpg)`,
          }}
        >
          {/* First Card */}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
            background: "#EEE",
            backgroundSize: "100%",
            backgroundImage: `url(https://images.pexels.com/photos/1078983/pexels-photo-1078983.jpeg?cs=srgb&dl=pexels-oliver-sj%C3%B6str%C3%B6m-1078983.jpg&fm=jpg)`,
          }}
        >
          {/* First Card */}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
            background: "#EEE",
            backgroundSize: "100%",
            backgroundImage: `url(https://images.pexels.com/photos/1078983/pexels-photo-1078983.jpeg?cs=srgb&dl=pexels-oliver-sj%C3%B6str%C3%B6m-1078983.jpg&fm=jpg)`,
          }}
        >
          {/* First Card */}
        </div>
      </ItemsCarousel>
    </div>
  );
};

export default ThemeComponent;
